/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDto } from '../../models/page-dto';
import { SiteUserWithMailDto } from '../../models/site-user-with-mail-dto';

export interface SiteControllerFindBySite$Params {
  id: string;
  order?: 'ASC' | 'DESC';
  page?: number;
  take?: number;
}

export function siteControllerFindBySite(http: HttpClient, rootUrl: string, params: SiteControllerFindBySite$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto & {
'data'?: Array<SiteUserWithMailDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, siteControllerFindBySite.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('order', params.order, {});
    rb.query('page', params.page, {});
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDto & {
      'data'?: Array<SiteUserWithMailDto>;
      }>;
    })
  );
}

siteControllerFindBySite.PATH = '/sites/{id}/users';
